/** Speculative navigation must never reject globally or reload the active editor. */
export function createPagePrefetcher() {
  const prefetched = new Set<string>();
  return (id: string, importer: () => Promise<unknown>): void => {
    if (prefetched.has(id)) return;
    prefetched.add(id);
    void Promise.resolve().then(importer).catch(() => {
      // A later hover/navigation may try again after a temporary network failure.
      prefetched.delete(id);
    });
  };
}
